import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
const sendToAnalytics = (metric) => {
  // In production, send to your analytics service
  if (process.env.NODE_ENV === 'development') {
    console.log('Performance metric:', metric);
  }
};

reportWebVitals(sendToAnalytics);

// Register service worker for offline support
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
